import global from './_global';
import defaults from './defaults';
import mixins from './mixins';
import gradients from './gradients';
import typography from './typography';
import colors from './colors';
import branding from './branding';

const theme = {
    global,
    defaults,
    mixins,
    gradients,
    typography,
    branding,
    colors,
};

export default theme;
